import React from "react";
import styled from "styled-components";
import { Icon, Tooltip, Text } from "@ui-component-library";

const IconBubble = ({ icon, bgColor, iconColor, rotation }) => {
  return (
    <div
      className={`flex justify-center items-center bg-${bgColor} rounded-full`}
      style={{ width: "40px", height: "40px" }}
    >
      <Icon
        name={icon}
        size="large"
        spacing="small"
        className={`fill-${iconColor} bg-${bgColor}`}
      />
    </div>
  );
};

const MetricCard = ({
  label,
  value,
  icon,
  bgColor,
  iconColor,
  rotation,
  suffix,
}) => {
  let formattedValue = value;

  if (!isNaN(Number(formattedValue)) && formattedValue !== " ") {
    formattedValue = Math.round(Number(formattedValue));
  }

  if (formattedValue?.length > 22) {
    formattedValue = (
      <Tooltip aria-label={formattedValue} content={formattedValue}>
        {formattedValue.slice(0, 22)}...
      </Tooltip>
    );
  }

  return (
    <Wrapper className="text-center">
      <div className="flex flex-col items-center gap-2">
        <IconBubble
          icon={icon}
          bgColor={bgColor}
          iconColor={iconColor}
          rotation={rotation}
        />
        <Text variant="text-sm/leading-normal/medium" className="text-pebble-500 mt-2">
          {label}
        </Text>
        <Text variant="text-xl/leading-normal/medium" className="text-charcoal-500">
          {formattedValue}
          {formattedValue !== "-" && suffix}
        </Text>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  min-width: 88px;

  @media (min-width: 992px) {
    min-width: 112px;
  }
`;

export { MetricCard };
